export function optionLabel (options, key, value) {
  if (value === undefined || value === null || value === '') return '-'
  const choices = Array.isArray(options[key]) ? options[key] : []
  const match = choices.find(choice => String(choice.value) === String(value))
  return match ? match.label : String(value)
}

export function displayValue (value) {
  return value === undefined || value === null || value === '' ? '-' : String(value)
}

export function leadDisplayName (value) {
  return String(value || '').trim() || '未命名客资'
}

export function editableIdentity (value) {
  const text = String(value || '')
  return text === '-' || text.includes('*') ? '' : text
}

export function enabledChoices (options, key) {
  const choices = Array.isArray(options[key]) ? options[key] : []
  return choices.filter(choice => choice.disabled !== true && choice.enabled !== false)
}

export function choicesWithHistoricalValue (options, key, originalValue) {
  const choices = enabledChoices(options, key)
  if (!originalValue || choices.some(choice => String(choice.value) === String(originalValue))) return choices
  return [{ value: originalValue, label: String(originalValue), historical: true }, ...choices]
}

export function choicesWithHistoricalValues (options, key, originalValues) {
  const choices = enabledChoices(options, key)
  const values = Array.isArray(originalValues) ? originalValues : []
  const missing = values.filter(value => !choices.some(choice => String(choice.value) === String(value)))
  return missing.map(value => ({ value, label: String(value), historical: true })).concat(choices)
}

export function normalizeSelection (value, fallback) {
  const source = Array.isArray(value) ? value : (fallback === undefined || fallback === null || fallback === '' ? [] : [fallback])
  return source.reduce((result, item) => {
    const normalized = item && typeof item === 'object'
      ? (item.code !== undefined ? item.code : (item.value !== undefined ? item.value : item.id))
      : item
    if (normalized === undefined || normalized === null || normalized === '') return result
    if (!result.some(existing => String(existing) === String(normalized))) result.push(normalized)
    return result
  }, [])
}

export function normalizeWecomTagGroups (groups) {
  return (Array.isArray(groups) ? groups : []).reduce((result, group, groupIndex) => {
    const items = (Array.isArray(group.tags) ? group.tags : []).reduce((tags, tag) => {
      const value = tag.id !== undefined ? tag.id : tag.value
      const label = String(tag.name || tag.label || '').trim()
      if (value === undefined || value === null || value === '' || !label) return tags
      tags.push({ value, label, disabled: tag.disabled === true || tag.enabled === false })
      return tags
    }, [])
    if (items.length) result.push({ id: group.id || `tag-group-${groupIndex}`, name: group.groupName || group.name || group.label || '未分组标签', items })
    return result
  }, [])
}

export function buildWecomTagFilters (groups, selections = {}) {
  return (Array.isArray(groups) ? groups : []).reduce((result, group) => {
    const groupId = group && group.id
    if (groupId === undefined || groupId === null || groupId === '') return result

    const selectedIds = Array.isArray(selections[String(groupId)]) ? selections[String(groupId)] : []
    const activeItems = Array.isArray(group.items) ? group.items.filter(item => !item.disabled) : []
    const tagIds = selectedIds.reduce((ids, selectedId) => {
      const item = activeItems.find(tag => String(tag.value) === String(selectedId))
      if (item && !ids.some(id => String(id) === String(item.value))) ids.push(item.value)
      return ids
    }, [])
    if (tagIds.length) result.push({ groupId, tagIds })
    return result
  }, [])
}

export function wecomTagGroupsWithHistoricalValues (groups, selectedIds) {
  const selected = Array.isArray(selectedIds) ? selectedIds : []
  const inactiveItems = {}
  const activeGroups = (Array.isArray(groups) ? groups : []).reduce((result, group) => {
    const activeItems = (Array.isArray(group.items) ? group.items : []).filter(item => {
      if (item.disabled) {
        inactiveItems[String(item.value)] = item
        return false
      }
      return true
    })
    if (activeItems.length) result.push({ ...group, items: activeItems })
    return result
  }, [])
  const activeIds = activeGroups.reduce((ids, group) => ids.concat(group.items.map(item => String(item.value))), [])
  const historicalItems = selected
    .filter(value => !activeIds.includes(String(value)))
    .map(value => {
      const inactiveItem = inactiveItems[String(value)]
      const label = inactiveItem ? inactiveItem.label : `历史标签 #${value}`
      return { value, label: `${label}（已失效）`, historical: true, disabled: false }
    })
  return historicalItems.length
    ? [{ id: '__historical_wecom_tags__', name: '已失效标签', items: historicalItems }, ...activeGroups]
    : activeGroups
}

export function currentWecomTagIds (groups, selectedIds) {
  const activeIds = (Array.isArray(groups) ? groups : []).reduce((ids, group) => {
    const groupIds = (Array.isArray(group.items) ? group.items : [])
      .filter(item => !item.disabled)
      .map(item => String(item.value))
    return ids.concat(groupIds)
  }, [])
  return (Array.isArray(selectedIds) ? selectedIds : []).filter(id => activeIds.includes(String(id)))
}

export function isLeadBound (lead = {}) {
  const status = String(lead.bindingStatus || '').toLowerCase()
  return status ? ['bound', 'linked'].includes(status) : Number(lead.boundContactId || lead.contactId || 0) > 0
}
